// src/config/wakeUpRelease.ts

// 11 November 2026, 11:11 AM Australia/Melbourne (AEDT).
// Store the release time as an absolute UTC instant.
export const WAKE_UP_RELEASE_TIME = Date.parse(
  "2026-11-11T00:11:00Z"
);

export const WAKE_UP_SERIES_ID = "wake-up";

export function isWakeUpReleased(): boolean {
  return Date.now() >= WAKE_UP_RELEASE_TIME;
}